import { useEffect, useState } from 'react';
import { listDealPayments, syncDealPayments } from '../../../accounting/services/deal-accounting-links';

// Share the same accounting read between the installment plan and linked receipts.
export default function useDealAccountingPayments(deal, dealType, enabled = true) {
  const [result, setResult] = useState({ key: '', payments: [], loading: false, error: '' });
  const [revision, setRevision] = useState(0);
  const completed = dealType === 'completato';
  const active = enabled && Boolean(deal?.id) && dealType !== 'proposta';
  const key = active ? `${dealType}:${deal.id}` : '';
  const dealId = deal?.id;

  useEffect(() => {
    if (!active) return undefined;
    let current = true;
    setResult({ key, payments: [], loading: true, error: '' });
    listDealPayments(dealId, completed).then(
      (payments) => { if (current) setResult({ key, payments, loading: false, error: '' }); },
      (cause) => { if (current) setResult({ key, payments: [], loading: false, error: cause.message }); }
    );
    return () => { current = false; };
  }, [active, key, dealId, completed, revision]);

  async function synchronize() {
    setResult({ key, payments: [], loading: true, error: '' });
    try {
      await syncDealPayments(dealId, completed);
      setRevision((value) => value + 1);
    } catch (cause) {
      setResult((current) => current.key === key ? { key, payments: [], loading: false, error: cause.message } : current);
    }
  }

  return {
    ...(key && result.key === key ? result : { payments: [], loading: active, error: '' }),
    synchronize,
  };
}
